import {
  CheckCheck,
  CheckCircle,
  ClipboardCheck,
  Clock,
  CreditCard,
  Loader,
  ShieldX,
  TrendingDown,
  TrendingUp,
} from 'lucide-react';
import i18n from '../i18n';

export const types = {
  enroll: i18n.t('enroll'),
  sitevisit: i18n.t('site_visit'),
  online: i18n.t('online'),
  offline: i18n.t('offline'),
  wallet: i18n.t('wallet'),
};

export const DeliveryStatus = {
  pending: 1,
  approved: 2,
  rejected: 3,
  fundAdded: 4,
  fundDeduct: 5,
  financeSettled: 6,
  loadingStarted: 7,
  loadingCompleted: 8,
  completed: 9,
};

export const DELIVERY_STATUS = {
  1: 'Pending',
  2: 'Approved',
  3: 'Rejected',
  4: 'Fund Added',
  5: 'Fund Deducted',
  6: 'Finance Settled',
  7: 'Loading Started',
  8: 'Loading Completed',
  9: 'Completed',
};

export const DELIVERY_STATUS_ICONS = {
  1: Clock, // Pending
  2: CheckCircle, // Approved
  3: ShieldX, // Rejected
  4: TrendingUp, // Fund Added
  5: TrendingDown, //Fund Deducted
  6: CreditCard, //Finance Settle
  7: Loader, //Loading Started
  8: CheckCheck, //Loadting Completed
  9: ClipboardCheck, //Project Completed
};

export const CLIENT_APPROVAL = {
  1: 'Pending',
  2: 'Approved',
  3: 'Rejected',
  4: 'Approved',
  5: 'Approved',
  6: 'Approved',
  7: 'Loading Started',
  8: 'Loading Completed',
  9: 'Completed',
};

export const AUCTION_STATUS = {
  N: 'Pending',
  A: 'Active',
  E: 'Expired',
};
export const AUCTION_APPROVE_STATUS = {
  NU: 'Pending',
  A: 'Client Approved',
  R: 'Rejected',
};

export const CLIENT_PAYMENT_TYPE = {
  bidder: 'From Bidder',
  add_fund: 'Fund Added By PM',
  wallet_swap: 'Wallet Swap',
};

export const BADGE_COLORS = {
  // Pending - amber/yellow
  Approved: '#3B82F6', // Approved - blue
  Rejected: '#EF4444', // Rejected - red
  'Fund Added': '#10B981', // Fund Added - green
  'Fund Deducted': '#F97316', // Fund Deducted - orange
  'Finance Settled': '#14B8A6', // Finance Settled - teal
  'Loading Started': '#6366F1', // Loading Started - indigo
  'Loading Completed': '#8B5CF6', // Loading Completed - purple
  Completed: '#22C55E', // Completed - bright green
  'Bidder Fund Added': '#F97316', // Fund added - orange
  'FS Approved': '#14B8A6', // Finance Support Approved - teal
  'FM Approved': '#22C55E', // Finance Admin Approved- bright green,
  'FS Rejected': '#EF4444',
  'FM Rejected': '#EF4444',
  Active: '#22C55E',
  Expired: '#EF4444',
  'قيد الانتظار': '#FBBF24',
  نشط: '#22C55E',
  منتهي: '#EF4444',
};

export const WALLET_STATUS = {
  pending: 'F',
  approved: 'A',
  Rrejected: 'rejected',
};

export const TEST_WALLET_STATUS = {
  pending: 'B',
  approved: 'FS',
  completed: 'FA',
  rejected: 'MR',
};

export const DELIVERY_STATUS_REVERSE = {
  pending: 1,
  approved: 2,
  rejected: 3,
  fundAdded: 4,
  fundDeducted: 5,
  financeSettled: 6,
  LoadingStarted: 7,
  LoadingCompleted: 8,
  Completed: 9,
};

export const TRANSACTION_STATUS = {
  B: 'Pending',
  FS: 'Finance Support Approved',
  FA: 'Finance Approved', //Auction Payment Finance Approved
  SR: 'Finance Support Rejected',
  AR: 'Finance Manager Rejected',
  R: 'Finance Approved', //Withdrawal Finance Approved
  A: 'Approved',
  P: 'Offline Recharge Pending', //Offline Recharge Pending
  F: 'Recharge Admin Approved', //Recharge Admin Approved
  W: 'Withdrawal Requested', //Withdrawal Bidder Requested
  WA: 'Admin Approved', //Withdrawal Admin Approved
  WR: 'Withdrawl Rejected', //New
  OR: 'Recharge Rejected', //New
};

export const NEW_TRANSACTION_STATUS = {
  B: {
    text: 'Pending',
    color: '#f59e0b',
  },
  FS: {
    text: 'Finance Support Approved',
    color: '#3b82f6',
  },
  FA: {
    text: 'Finance Approved',
    color: '#10b981',
  },
  SR: {
    text: 'Finance Support Rejected',
    color: '#ef4444',
  },
  AR: {
    text: 'Finance Manager Rejected',
    color: '#dc2626',
  },
  R: {
    text: 'Finance Approved',
    color: '#10b981',
  },
  A: {
    text: 'Approved',
    color: '#22c55e',
  },
  P: {
    text: 'Pending',
    color: '#f59e0b',
  },
  F: {
    text: 'Admin Approved',
    color: '#0ea5e9',
  },
  W: {
    text: 'Withdrawal Requested',
    color: '#f97316',
  },
  WA: {
    text: 'Admin Approved',
    color: '#0ea5e9',
  },
  WR: {
    text: 'Withdrawal Rejected',
    color: '#dc2626',
  },
  RA: {
    text: 'Admin Rejected',
    color: '#dc2626',
  },
  RF: {
    text: 'Finance Rejected',
    color: '#dc2626',
  },
};

export const TRANSACTION_METHODS = {
  online: {
    text: 'Online',
    color: '#2563eb', // Blue
  },
  offline: {
    text: 'Offline',
    color: '#f59e0b', // Amber
  },
  wallet: {
    text: 'Wallet',
    color: '#10b981', // Green
  },
};

export const TRANSACTION_TYPES = {
  admin: {
    text: 'Admin',
    color: '#6b7280', // Gray
  },
  sitevisit: {
    text: 'Site Visit',
    color: '#8b5cf6', // Purple
  },
  enroll: {
    text: 'Enrollment',
    color: '#0ea5e9', // Sky Blue
  },
  wallet_recharge: {
    text: 'Recharge',
    color: '#22c55e', // Green
  },
  withdraw: {
    text: 'Withdrawal',
    color: '#ef4444', // Red
  },
  client_payment: {
    text: 'Auction Payment',
    color: '#2563eb', // Blue
  },
  client_withdraw: {
    text: 'Client Withdraw',
    color: '#f97316', // Orange
  },
  client_remittance: {
    text: 'Client Remittance',
    color: '#14b8a6', // Teal
  },
  wallet_swap: {
    text: 'Wallet Swap',
    color: '#a855f7', // Violet
  },
};

export const USER_TRANSACTION_STATUS = {
  B: {
    text: i18n.t('pending'),
    color: '#f59e0b',
  },
  FS: {
    text: 'Processing',
    color: '#3b82f6',
  },
  FA: {
    text: i18n.t('approved'),
    color: '#10b981',
  },
  SR: {
    text: 'Rejected',
    color: '#ef4444',
  },
  AR: {
    text: i18n.t('rejected'),
    color: '#dc2626',
  },
  R: {
    text: i18n.t('approved'),
    color: '#10b981',
  },
  A: {
    text: i18n.t('approved'),
    color: '#22c55e',
  },
  P: {
    text: i18n.t('waiting_for_admin_approval'),
    color: '#f59e0b',
  },
  F: {
    text: i18n.t('waiting_for_finance_approval'),
    color: '#0ea5e9',
  },
  W: {
    text: i18n.t('withdrawal_requested'),
    color: '#f97316',
  },
  WA: {
    text: i18n.t('waiting_for_finance_approval'),
    color: '#22c55e',
  },
  WR: {
    text: i18n.t('withdrawal_rejected'),
    color: '#dc2626',
  },
  RA: {
    text: i18n.t('rejected'),
    color: '#dc2626',
  },
  RF: {
    text: i18n.t('rejected'),
    color: '#dc2626',
  },
};

export const ENROLLMENT_STATUS = {
  WC: {
    text: i18n.t('awaiting_client_approval'),
    color: '#f59e0b',
  },
  RC: {
    text: i18n.t('client_rejected'),
    color: '#ef4444',
  },
  N: {
    text: i18n.t('awaiting_mzadcom_approval'),
    color: '#f59e0b',
  },
  A: {
    text: i18n.t('approved'),
    color: '#10b981',
  },
  R: {
    text: i18n.t('mzadcom_rejected'),
    color: '#dc2626',
  },
};

export const ENROLLMENT_REFUND_STATUS = {
  A: {
    text: i18n.t('awaiting_mzadcom_approval'),
    color: '#f59e0b',
  },
  WC: {
    text: i18n.t('awaiting_client_approval'),
    color: '#f59e0b',
  },
  RC: {
    text: i18n.t('client_rejected'),
    color: '#ef4444',
  },
  PA: {
    text: i18n.t('approved'),
    color: '#10b981',
  },

  RR: {
    text: i18n.t('mzadcom_rejected'),
    color: '#dc2626',
  },
};

export const ENROLLMENT_TYPE = {
  0: {
    text: i18n.t('auction_level'),
    color: '#f59e0b',
  },
  1: {
    text: i18n.t('group_level'),
    color: '#0ea5e9',
  },
};

export const REFUND_ELIGIBLE_TYPE = {
  true: {
    text: i18n.t('eligible'),
    color: '#10b981',
  },
  false: {
    text: i18n.t('not_eligible'),
    color: '#dc2626',
  },
};

export const PAYMENT_ACCOUNT_TYPE = {
  1: {
    text: i18n.t('mzadcom_account'),
    color: '#f59e0b',
  },
  2: {
    text: i18n.t('client_account'),
    color: '#0ea5e9',
  },
};

export const STRATEGY_TYPE = {
  0: {
    text: i18n.t('normal'),
    color: '#10b981',
  },
  1: {
    text: i18n.t('strategy'),
    color: '#dc2626',
  },
};
